import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react'
import RangeSlider from 'react-range-slider-input';

export default observer(function EngagementRateSlider({ label, min, max, onInput, leftValue, rightValue }) {
  const [minValue, setMinValue] = useState(min)

  const onRangeChange = ([min, max]) => {
    setMinValue(max)
    onInput([0, max])
  }

  useEffect(() => {
    setMinValue(max)
  }, [min, max])

  return (
    <div>
      <div className="flex justify-between items-center">
        {label ? <p className="font-semibold dark:text-white">{label}</p> : <span />}
        <div className="flex items-center gap-1.5">
          <div className="flex rounded-full items-center bg-rb-grey px-2 py-0.5 dark:bg-rb-dark-mode-lighter">
            <div className="rounded-full w-2.5 h-2.5 mr-1.5 bg-[#BBF7D0]" />
            <p className="text-xs font-medium text-rb-mat-grey dark:text-gray-300">Low</p>
          </div>
          <div className="flex rounded-full items-center bg-rb-grey px-2 py-0.5 dark:bg-rb-dark-mode-lighter">
            <div className="rounded-full w-2.5 h-2.5 mr-1.5 bg-[#4ADE80]" />
            <p className="text-xs font-medium text-rb-mat-grey dark:text-gray-300">Mid</p>
          </div>
          <div className="flex rounded-full items-center bg-rb-grey px-2 py-0.5 dark:bg-rb-dark-mode-lighter">
            <div className="rounded-full w-2.5 h-2.5 mr-1.5 bg-[#16A34A]" />
            <p className="text-xs font-medium text-rb-mat-grey dark:text-gray-300">High</p>
          </div>
        </div>

      </div>
      <div className="w-full relative mt-9 mb-5">
        <RangeSlider
          min={leftValue}
          max={rightValue}
          value={[0, minValue]}
          thumbsDisabled={[true, false]}
          rangeSlideDisabled={true}
          onInput={onRangeChange}
          step={0.25}
          className="single-thumb"
        />
        <div className="absolute w-full top-0 flex">
          <div className="bg-[#BBF7D0] w-1/3 h-2 z-10 rounded-lg top-0"></div>
          <div className="bg-[#4ADE80] w-1/3 h-2 z-10 rounded-lg top-0"></div>
          <div className="bg-[#16A34A] w-1/3 h-2 z-10 rounded-lg top-0"></div>
        </div>

        <div className="absolute flex top-0 justify-evenly w-full">
          <div className="bg-white w-2 h-2 z-10 rounded-full"></div>
          <div className="bg-white w-2 h-2 z-10 rounded-full"></div>
        </div>

        <div className="absolute top-4 text-xs text-gray-400 rounded-full left-0">0%</div>
        <div className="absolute -ml-2.5 top-4 text-xs text-gray-400 rounded-full left-1/3">2%</div>
        <div className="absolute -ml-2.5 top-4 text-xs text-gray-400 rounded-full left-2/3">4%</div>
        <div className="absolute top-4 text-xs text-gray-400 rounded-full right-0">6%+</div>

      </div>
    </div>
  )
})